// extracted by css-extract-rspack-plugin
export default {"headerTwo":"ChangeTwoFactorDevice_headerTwo__VkrFK","layoutContainer":"ChangeTwoFactorDevice_layoutContainer__LLnQS"};